import LogoutModal from './logout-modal';

export default LogoutModal;